import { Branding } from '../branding';

export const brandingValues = {
  branding: Branding.Walmart,
  httpBrand: '1',
  css: 'wmt',
  segmentProduct: 'w2w',
  locale: 'WA', // used in localization
  partnerName: 'Walmart',
  logo: '',
};



// WEBPACK FOOTER //
// ./src/environment/branding/walmart.ts